import { render, staticRenderFns } from "./industryNews.vue?vue&type=template&id=5f1bfab4&scoped=true"
import script from "./industryNews.vue?vue&type=script&lang=js"
export * from "./industryNews.vue?vue&type=script&lang=js"
import style0 from "./industryNews.vue?vue&type=style&index=0&id=5f1bfab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1bfab4",
  null
  
)

export default component.exports